import { PageTypes } from '@shared/types';
export const documentTypes = {
    [PageTypes.certificate]: 'Inspection Certificate',
    [PageTypes.tags]: 'Tags',
    [PageTypes.undefined]: 'Not Relevant',
    [PageTypes.delivery]: 'Delivery Record',
    [PageTypes.processing_sheet]: 'Processing Sheet',
    [PageTypes.processing_tags]: 'Processing Tags'
};
export const summaryTableDocumentTypes = Object.assign(Object.assign({}, documentTypes), { summary_list: 'Summary List' });
